import { ActionIcon } from "@mantine/core";

export const actionIconComponentSettings = ActionIcon.extend({
  defaultProps: {
    color: "bay",
    variant: "subtle",
  },
});
